import React, { Component, useState } from "react";
import { useDraggable } from "react-use-draggable-scroll";
import { useRef } from "react";
import styled from "styled-components";

interface Props {
  timeArray: any;
  slotData: any;
  productInfo: any;
  masterProdInfo: any;
}

const getStatusBackground = (status: any) => {
  type colorOptions = {
    [key: string]: string;
  };
  let statusObj: colorOptions = {
    blockedSlot: "rgb(231, 233, 238)",
    blockedForExtra: "#467CF8",
    blockedDate: "#D85347",
    used: "#000",
    blocking: "#E6E6E6",
    inactive: "#FFF",
    booking: "#D85347",
  };
  return statusObj[status] || "#FFF";
};

const getStatusColor = (status: any) => {
  type colorOptions = {
    [key: string]: string;
  };
  let statusObj: colorOptions = {
    blockedSlot: "#AAA",
    blockedDate: "#FFF",
    used: "#FFF",
    blockedForExtra: "#FFF",
    blocking: "#AAA",
    inactive: "#FFF",
    booking: "#FFF",
  };
  return statusObj[status];
};

const SlotLayout = ({
  slotData,
  timeArray,
  productInfo,
  masterProdInfo,
}: Props) => {
  const [activeLabel, setActiveLabel] = useState("");
  const refDrag =
    useRef<HTMLDivElement>() as React.MutableRefObject<HTMLInputElement>;
  const { events: eventsDrag } = useDraggable(refDrag, {
    applyRubberBandEffect: true,
  });

  const getTypeKey = (typeKey: string, prodKey: string) => {
    let maxQty =
      masterProdInfo.filter((prod: any) => prod._id === prodKey)[0]
        .aquaAvailableUnit || 1;
    return Number(typeKey) > maxQty ? `+${Number(typeKey) % maxQty}` : typeKey;
  };

  const handleLabelClick = (id: any) => {
    if (id && id === activeLabel) {
      setActiveLabel("");
    } else {
      setActiveLabel(id);
    }
  };

  const getTime = (timeString: any) => {
    const startTimeStr = timeString.slice(0, 4);
    const endTimeStr = timeString.slice(5);

    let startHour = parseInt(startTimeStr.slice(0, 2));
    let endHour = parseInt(endTimeStr.slice(0, 2));
    const startMinute = parseInt(startTimeStr.slice(2));
    const endMinute = parseInt(endTimeStr.slice(2));

    let startSuffix = "AM";
    if (startHour >= 12) {
      startSuffix = "PM";
      if (startHour > 12) {
        startHour -= 12;
      }
    }

    let endSuffix = "AM";
    if (endHour >= 12) {
      endSuffix = "PM";
      if (endHour > 12) {
        endHour -= 12;
      }
    }

    const formattedStartTime = `${startHour
      .toString()
      .padStart(2, "0")}:${startMinute
      .toString()
      .padStart(2, "0")} ${startSuffix}`;
    const formattedEndTime = `${endHour.toString().padStart(2, "0")}:${endMinute
      .toString()
      .padStart(2, "0")} ${endSuffix}`;
    return `${formattedStartTime} - ${formattedEndTime}`;
  };

  const getStatusUI = (typeKey: any, key: any, time: any) => {
    if (time?.status === "active") {
      return getTypeKey(typeKey, key).includes("+") &&
        time?.blockedFor === "booking"
        ? "blockedForExtra"
        : time?.blockedFor;
    } else if (time?.status === "used") {
      return "used";
    } else {
      return "inactive";
    }
  };

  const getStatus = (time: any) => {
    if (time?.blockedFor === "available" || time?.status === "cancelled") {
      return "";
    }
    if (time?.status === "used") {
      return "used";
    }
    return time?.blockedFor;
  };

  const getDuration = (time: any) => {
    if (time.blockedFor === "available" || time.status === "cancelled") {
      return "";
    }
    return `${time?.aquaDuration} Min`;
  };

  return (
    <SlotLayoutContainer>
      <GameGrid>
        <Cell>
          <LogoCell>
            <img src={require("../../assets/images/aqua_logo.png")} />
          </LogoCell>
        </Cell>
        {Object.keys(slotData).map((key: any) => (
          <LeftPanelContainer>
            <GameNameColumn>
              <GameNameCell>{productInfo[key]}</GameNameCell>
            </GameNameColumn>
            <TypeNameColumn>
              {
                //@ts-ignore
                Object.keys(slotData[key]).map((typeKey) => (
                  <GameTypeCell>{getTypeKey(typeKey, key)}</GameTypeCell>
                ))
              }
            </TypeNameColumn>
          </LeftPanelContainer>
        ))}
      </GameGrid>
      <TimeGridContainer {...eventsDrag} ref={refDrag}>
        <TimeGrid timeArray={timeArray}>
          {timeArray.length > 0 &&
            timeArray.map((time: any) => <TimeCell>{getTime(time)}</TimeCell>)}
        </TimeGrid>
        {Object.keys(slotData).map((key: any, indexMain) => (
          <TimeGrid timeArray={timeArray}>
            {
              // @ts-ignore
              Object.keys(slotData[key]).map((typeKey, indexSlot) =>
                // @ts-ignore
                Object.keys(slotData[key][typeKey]).map(
                  (timeKeys, indexType) => (
                    <BookingCell>
                      {
                        // @ts-ignore
                        slotData[key][typeKey][timeKeys]?.map(
                          (time: any, indexTime: any) => (
                            <BookingCellInner
                              // @ts-ignore
                              width={getWidth(slotData[key][typeKey][timeKeys])}
                              status={getStatusUI(typeKey, key, time)}
                            >
                              <span>{getStatus(time)}</span>
                              {time?.aquaDuration && (
                                <span>{getDuration(time)}</span>
                              )}
                              {time?.blockedFor &&
                                time?.blockedFor !== "available" && (
                                  <ActionContainer>
                                    <EditIcon
                                      onClick={() =>
                                        handleLabelClick(
                                          (
                                            productInfo[key] +
                                            indexMain +
                                            indexSlot +
                                            indexType +
                                            indexTime
                                          ).toString()
                                        )
                                      }
                                      src={require("../../assets/images/edit-slot.png")}
                                    />
                                    {activeLabel ===
                                      (
                                        productInfo[key] +
                                        indexMain +
                                        indexSlot +
                                        indexType +
                                        indexTime
                                      ).toString() && (
                                      <SlotData>
                                        {time?.blockedFor === "booking"
                                          ? "Active"
                                          : "Enable"}
                                        Slot
                                      </SlotData>
                                    )}
                                  </ActionContainer>
                                )}
                            </BookingCellInner>
                          )
                        )
                      }
                    </BookingCell>
                  )
                )
              )
            }
          </TimeGrid>
        ))}
      </TimeGridContainer>
    </SlotLayoutContainer>
  );
};

const SlotLayoutContainer = styled.div`
  border-bottom: 1px solid #cdcdcd;
  display: grid;
  grid-template-columns: 15rem 1fr;
  @media only screen and (max-width: 768px) {
    grid-template-columns: 10rem 1fr;
  }
`;

const Cell = styled.div`
  font-size: 0.75rem;
  height: 4rem;
`;

const LogoCell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #cdcdcd;
  border-left: 1px solid #cdcdcd;
  border-right: 1px solid #fff;
  border-bottom: 1px solid #fff;
  height: 100%;
`;

const GameGrid = styled.div``;

const GameNameColumn = styled.div`
  width: 70%;
  border-right: 1px solid #cdcdcd;
  border-top: 1px solid #cdcdcd;
  border-left: 1px solid #cdcdcd;
`;
const TypeNameColumn = styled.div`
  width: 30%;
`;
const LeftPanelContainer = styled.div`
  width: 100%;
  display: flex;
`;

const TimeCell = styled(Cell)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #e7e9ee;
  border-left: 1px solid #cdcdcd;
  border-top: 1px solid #cdcdcd;
  box-sizing: border-box;
`;

const GameNameCell = styled(Cell)`
  width: 100%;
  background: #e7e9ee;
  color: #505470;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  flex: 1;
  padding: 0.5rem;
  box-sizing: border-box;
  text-align: center;
  @media only screen and (max-width: 768px) {
  }
`;

const GameTypeCell = styled(Cell)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #e7e9ee;
  border-top: 1px solid #cdcdcd;
  text-align: center;
`;

const getWidth = (slotData: any) => {
  let width = 100 / slotData.length;
  return width ? width + "%" : "100%";
};

const BookingCell = styled(Cell)`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #cdcdcd;
  // border-right: 1px solid #cdcdcd;
  // position: absolute;
`;

interface BookInnerCellProps {
  width: string;
  status: string;
}

const BookingCellInner = styled.span<BookInnerCellProps>`
  width: ${(props) => props.width || "100%"};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-transform: capitalize;
  background: ${(props) => getStatusBackground(props.status)};
  color: ${(props) => getStatusColor(props.status)};
  height: 4rem;
  border-left: 1px solid #cdcdcd;
  // border-bottom: 1px solid #cdcdcd;
  position: relative;
`;

const ActionContainer = styled.div`
  width: 100%;
  position: absolute;
  top: 0rem;
  right: 0rem;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const EditIcon = styled.img`
  width: 1.25rem;
  cursor: pointer;
`;

const SlotData = styled.div`
  width: 90%;
  text-align: center;
  background: white;
  padding: 0.25rem;
  color: black;
  box-sizing: border-box;
  padding: 0.5rem 0;
  border: 1px solid #e4e6ee;
  border-radius: 0.25rem;
  bottom: 0;
  margin-right: 0.05rem;
  filter: drop-shadow(0px 0px 14px rgba(0, 0, 0, 0.25));
`;

const TimeGridContainer = styled.div`
  overflow-x: auto;
  scrollbar-width: none;
  border-right: 1px solid #cdcdcd;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

interface TimeGridProps {
  timeArray: any;
}

const TimeGrid = styled.div<TimeGridProps>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.timeArray.length}, 10rem);
  grid-template-rows: auto;
`;

export default SlotLayout;
